{
  "about.blocks": "เซิร์ฟเวอร์ที่ได้รับการกลั่นกรอง",
  "about.contact": "ติดต่อ:",
  "about.default_locale": "ค่าเริ่มต้น",
  "about.domain_blocks.no_reason_available": "เหตุผลไม่พร้อมใช้งาน",
  "about.domain_blocks.preamble": "โดยทั่วไป Mastodon อนุญาตให้คุณดูเนื้อหาจากและโต้ตอบกับผู้ใช้จากเซิร์ฟเวอร์อื่นใดในจักรวาลสหพันธ์ นี่คือข้อยกเว้นที่ทำขึ้นในเซิร์ฟเวอร์นี้โดยเฉพาะ",
  "about.domain_blocks.silenced.explanation": "โดยทั่วไปคุณจะไม่เห็นโปรไฟล์และเนื้อหาจากเซิร์ฟเวอร์นี้ เว้นแต่คุณจะค้นหาเซิร์ฟเวอร์หรือเลือกรับเซิร์ฟเวอร์โดยการติดตามอย่างชัดเจน",
  "about.domain_blocks.silenced.title": "จำกัดอยู่",
  "about.domain_blocks.suspended.explanation": "จะไม่ประมวลผล จัดเก็บ หรือแลกเปลี่ยนข้อมูลจากเซิร์ฟเวอร์นี้ ทำให้การโต้ตอบหรือการสื่อสารใด ๆ กับผู้ใช้จากเซิร์ฟเวอร์นี้เป็นไปไม่ได้",
  "about.domain_blocks.suspended.title": "ระงับอยู่",
  "about.language_label": "ภาษา",
  "about.not_available": "ไม่ได้ทำให้ข้อมูลนี้พร้อมใช้งานในเซิร์ฟเวอร์นี้",
  "about.powered_by": "สื่อสังคมแบบกระจายศูนย์ที่ขับเคลื่อนโดย {mastodon}",
  "about.rules": "กฎของเซิร์ฟเวอร์",
  "account.account_note_header": "หมายเหตุส่วนบุคคล",
  "account.activity": "กิจกรรม",
  "account.add_note": "เพิ่มโน้ตส่วนบุคคล",
  "account.add_or_remove_from_list": "เพิ่มหรือเอาออกจากรายการ",
  "account.badges.admin": "ผู้ดูแล",
  "account.badges.blocked": "บล็อกอยู่",
  "account.badges.bot": "อัตโนมัติ",
  "account.badges.domain_blocked": "โดเมนที่ถูกบล็อก",
  "account.badges.group": "กลุ่ม",
  "account.badges.muted": "ปิดเสียงบัญชีแล้ว",
  "account.badges.muted_until": "ปิดเสียงบัญชีจนถึง {until}",
  "account.block": "ปิดกั้น @{name}",
  "account.block_domain": "ปิดกั้นโดเมน {domain}",
  "account.block_short": "ปิดกั้น",
  "account.blocked": "ปิดกั้นอยู่",
  "account.cancel_follow_request": "ยกเลิกการติดตาม",
  "account.copy": "คัดลอกลิงก์ไปยังโปรไฟล์",
  "account.direct": "กล่าวถึง @{name} แบบส่วนตัว",
  "account.disable_notifications": "หยุดแจ้งเตือนฉันเมื่อ @{name} โพสต์",
  "account.edit_note": "แก้ไขโน้ตส่วนบุคคล",
  "account.edit_profile": "แก้ไขโปรไฟล์",
  "account.edit_profile_short": "แก้ไข",
  "account.enable_notifications": "แจ้งเตือนฉันเมื่อ @{name} โพสต์",
  "account.endorse": "แสดงในโปรไฟล์",
  "account.familiar_followers_many": "ติดตามโดย {name1}, {name2}, และ {othersCount, plural, one {อีกหนึ่งผู้ใช้ที่คุณรู้จัก} other {# ผู้ใช้อื่น ๆ ที่คุณรู้จัก}}",
  "account.familiar_followers_one": "ติดตามโดย {name1}",
  "account.familiar_followers_two": "ติดตามโดย {name1} และ {name2}",
  "account.featured": "น่าสนใจ",
  "account.featured.accounts": "โปรไฟล์",
  "account.filters.all": "กิจกรรมทั้งหมด",
  "account.filters.boosts_toggle": "แสดงการดัน",
  "account.filters.posts_only": "โพสต์",
  "account.follow": "ติดตาม",
  "account.follow_back": "ติดตามกลับ",
  "account.follow_back_short": "ติดตามกลับ",
  "account.follow_request": "ขอติดตาม",
  "account.follow_request_cancel": "ยกเลิกคำขอ",
  "account.follow_request_cancel_short": "ยกเลิก",
  "account.follow_request_short": "ขอ",
  "account.followers": "ผู้ติดตาม",
  "account.followers.empty": "ยังไม่มีใครติดตามผู้ใช้นี้",
  "account.followers_counter": "{count, plural, other {{counter} ผู้ติดตาม}}",
  "account.followers_you_know_counter": "{counter} ที่คุณรู้จัก",
  "account.following": "กำลังติดตาม",
  "account.following_counter": "{count, plural, other {{counter} กำลังติดตาม}}",
  "account.follows.empty": "ผู้ใช้นี้ยังไม่ได้ติดตามใคร",
  "account.follows_you": "ติดตามคุณ",
  "account.go_to_profile": "ไปยังโปรไฟล์",
  "account.hide_reblogs": "ซ่อนการดันจาก @{name}",
  "account.in_memoriam": "เพื่อระลึกถึง",
  "account.join_modal.day": "วัน",
  "account.joined_short": "เข้าร่วมเมื่อ",
  "account.languages": "เปลี่ยนภาษาที่บอกรับ",
  "account.link_verified_on": "ตรวจสอบความเป็นเจ้าของของลิงก์นี้เมื่อ {date}",
  "account.locked_info": "มีการตั้งสถานะความเป็นส่วนตัวของบัญชีนี้เป็นล็อคอยู่ เจ้าของตรวจทานผู้ที่สามารถติดตามเขาด้วยตนเอง",
  "account.media": "สื่อ",
  "account.mention": "กล่าวถึง @{name}",
  "account.menu.remove_follower": "เอาผู้ติดตามออก",
  "account.moved_to": "{name} ได้ระบุว่าบัญชีใหม่ของเขาในตอนนี้คือ:",
  "account.mute": "ซ่อน @{name}",
  "account.mute_notifications_short": "ซ่อนการแจ้งเตือน",
  "account.mute_short": "ซ่อน",
  "account.muted": "ซ่อนอยู่",
  "account.mutual": "คุณติดตามกันและกัน",
  "account.no_bio": "ไม่ได้ให้คำอธิบาย",
  "account.node_modal.save": "บันทึก",
  "account.note.edit_button": "แก้ไข",
  "account.open_original_page": "เปิดหน้าดั้งเดิม",
  "account.posts": "โพสต์",
  "account.remove_from_followers": "เอา {name} ออกจากผู้ติดตาม",
  "account.report": "รายงาน @{name}",
  "account.requested_follow": "{name} ได้ขอติดตามคุณ",
  "account.share": "แชร์โปรไฟล์ของ @{name}",
  "account.show_reblogs": "แสดงการดันจาก @{name}",
  "account.statuses_counter": "{count, plural, other {{counter} โพสต์}}",
  "account.unblock": "เลิกปิดกั้น @{name}",
  "account.unblock_domain": "เลิกปิดกั้นโดเมน {domain}",
  "account.unblock_domain_short": "เลิกปิดกั้น",
  "account.unblock_short": "เลิกปิดกั้น",
  "account.unendorse": "ไม่แสดงในโปรไฟล์",
  "account.unfollow": "เลิกติดตาม",
  "account.unmute": "เลิกซ่อน @{name}",
  "account.unmute_notifications_short": "เลิกซ่อนการแจ้งเตือน",
  "account.unmute_short": "เลิกซ่อน",
  "account_edit.field_delete_modal.delete_button": "ลบ",
  "account_edit.image_delete_modal.delete_button": "ลบ",
  "account_edit.profile_tab.button_label": "ปรับแต่ง",
  "account_edit.save": "บันทึก",
  "account_edit.upload_modal.back": "ย้อนกลับ",
  "account_edit.upload_modal.next": "ถัดไป",
  "admin.dashboard.daily_retention": "อัตราการเก็บรักษาผู้ใช้ตามวันหลังจากการลงทะเบียน",
  "admin.dashboard.monthly_retention": "อัตราการเก็บรักษาผู้ใช้ตามเดือนหลังจากการลงทะเบียน",
  "admin.dashboard.retention.average": "ค่าเฉลี่ย",
  "admin.dashboard.retention.cohort": "เดือนที่ลงทะเบียน",
  "admin.dashboard.retention.cohort_size": "ผู้ใช้ใหม่",
  "admin.impact_report.instance_accounts": "โปรไฟล์ของบัญชีที่ที่นี่จะลบ",
  "admin.impact_report.instance_followers": "ผู้ติดตามที่ผู้ใช้ของเราจะสูญเสีย",
  "admin.impact_report.instance_follows": "ผู้ติดตามที่ผู้ใช้ของเขาจะสูญเสีย",
  "admin.impact_report.title": "ข้อมูลสรุปผลกระทบ",
  "alert.rate_limited.message": "โปรดลองใหม่หลังจาก {retry_time, time, medium}",
  "alert.rate_limited.title": "มีการจำกัดอัตรา",
  "alert.unexpected.message": "เกิดข้อผิดพลาดที่ไม่คาดคิด",
  "alert.unexpected.title": "อุปส์!",
  "alt_text_badge.title": "ข้อความแสดงแทน",
  "alt_text_modal.add_alt_text": "เพิ่มข้อความแสดงแทน",
  "alt_text_modal.add_text_from_image": "เพิ่มข้อความจากภาพ",
  "alt_text_modal.cancel": "ยกเลิก",
  "alt_text_modal.change_thumbnail": "เปลี่ยนภาพขนาดย่อ",
  "alt_text_modal.describe_for_people_with_hearing_impairments": "อธิบายสิ่งนี้สำหรับผู้คนที่มีความบกพร่องทางการได้ยิน…",
  "alt_text_modal.describe_for_people_with_visual_impairments": "อธิบายสิ่งนี้สำหรับผู้คนที่มีความบกพร่องทางการมองเห็น…",
  "alt_text_modal.done": "เสร็จสิ้น",
  "announcement.announcement": "ประกาศ",
  "annual_report.nav_item.badge": "ใหม่",
  "annual_report.summary.close": "ปิด",
  "annual_report.summary.followers.new_followers": "{count, plural, other {ผู้ติดตามใหม่}}",
  "annual_report.summary.most_used_app.most_used_app": "แอปที่ใช้มากที่สุด",
  "annual_report.summary.most_used_hashtag.most_used_hashtag": "แฮชแท็กที่ใช้มากที่สุด",
  "annual_report.summary.new_posts.new_posts": "โพสต์ใหม่",
  "annual_report.summary.percentile.we_wont_tell_bernie": "เราจะไม่บอก Bernie",
  "attachments_list.unprocessed": "(ยังไม่ได้ประมวลผล)",
  "audio.hide": "ซ่อนเสียง",
  "block_modal.remote_users_caveat": "เราจะขอให้เซิร์ฟเวอร์ {domain} เคารพการตัดสินใจของคุณ อย่างไรก็ตาม ไม่รับประกันการปฏิบัติตามข้อกำหนดเนื่องจากเซิร์ฟเวอร์บางแห่งอาจจัดการการปิดกั้นแตกต่างกัน โพสต์สาธารณะอาจยังคงปรากฏแก่ผู้ใช้ที่ไม่ได้เข้าสู่ระบบ",
  "block_modal.show_less": "แสดงน้อยลง",
  "block_modal.show_more": "แสดงเพิ่มเติม",
  "block_modal.they_will_know": "เขาสามารถเห็นว่ามีการปิดกั้นเขา",
  "block_modal.title": "ปิดกั้นผู้ใช้?",
  "boost_modal.combo": "คุณสามารถกดปุ่ม {combo} เพื่อข้ามสิ่งนี้ในครั้งถัดไป",
  "boost_modal.reblog": "ดันโพสต์?",
  "boost_modal.undo_reblog": "เลิกดันโพสต์?",
  "bundle_column_error.copy_stacktrace": "คัดลอกรายงานข้อผิดพลาด",
  "bundle_column_error.error.body": "ไม่สามารถแสดงผลหน้าที่ขอ ข้อผิดพลาดอาจเป็นเพราะข้อบกพร่องในโค้ดของเรา หรือปัญหาความเข้ากันได้ของเบราว์เซอร์",
  "bundle_column_error.error.title": "โอ้ ไม่!",
  "bundle_column_error.network.body": "มีข้อผิดพลาดขณะพยายามโหลดหน้านี้ นี่อาจเป็นเพราะปัญหาชั่วคราวกับการเชื่อมต่ออินเทอร์เน็ตของคุณหรือเซิร์ฟเวอร์นี้",
  "bundle_column_error.network.title": "ข้อผิดพลาดเครือข่าย",
  "bundle_column_error.retry": "ลองอีกครั้ง",
  "bundle_column_error.return": "กลับไปที่หน้าแรก",
  "bundle_column_error.routing.body": "ไม่พบหน้าที่ขอ คุณแน่ใจหรือไม่ว่า URL ในแถบที่อยู่ถูกต้อง?",
  "bundle_column_error.routing.title": "404",
  "bundle_modal_error.close": "ปิด",
  "bundle_modal_error.message": "มีบางอย่างผิดพลาดขณะโหลดหน้าจอนี้",
  "bundle_modal_error.retry": "ลองอีกครั้ง",
  "closed_registrations.other_server_instructions": "เนื่องจาก Mastodon เป็นแบบกระจายศูนย์ คุณสามารถสร้างบัญชีในเซิร์ฟเวอร์อื่นและยังคงโต้ตอบกับเซิร์ฟเวอร์นี้",
  "closed_registrations_modal.description": "ไม่สามารถสร้างบัญชีใน {domain} ได้ในปัจจุบัน แต่โปรดจำไว้ว่าคุณไม่จำเป็นต้องมีบัญชีใน {domain} โดยเฉพาะเพื่อใช้ Mastodon",
  "closed_registrations_modal.find_another_server": "ค้นหาเซิร์ฟเวอร์อื่น",
  "closed_registrations_modal.preamble": "Mastodon เป็นแบบกระจายศูนย์ ดังนั้นไม่ว่าคุณจะสร้างบัญชีของคุณที่ใด คุณจะสามารถติดตามและโต้ตอบกับใครก็ตามในเซิร์ฟเวอร์นี้ คุณยังสามารถโฮสต์บัญชีด้วยตนเองได้อีกด้วย!",
  "closed_registrations_modal.title": "การลงทะเบียนใน Mastodon",
  "collections.collection_name": "ชื่อ",
  "collections.visibility_public": "สาธารณะ",
  "column.about": "เกี่ยวกับ",
  "column.blocks": "ผู้ใช้ที่ปิดกั้นอยู่",
  "column.bookmarks": "ที่คั่นหน้า",
  "column.community": "เส้นเวลาในเซิร์ฟเวอร์",
  "column.create_list": "สร้างรายการ",
  "column.direct": "การกล่าวถึงแบบส่วนตัว",
  "column.directory": "เรียกดูโปรไฟล์",
  "column.domain_blocks": "โดเมนที่ปิดกั้นอยู่",
  "column.edit_list": "แก้ไขรายการ",
  "column.favourites": "รายการโปรด",
  "column.firehose": "ฟีดสด",
  "column.firehose_local": "ฟีดสดสำหรับเซิร์ฟเวอร์นี้",
  "column.firehose_singular": "ฟีดสด",
  "column.follow_requests": "คำขอติดตาม",
  "column.home": "หน้าแรก",
  "column.list_members": "จัดการสมาชิกของรายการ",
  "column.lists": "รายการ",
  "column.mutes": "ผู้ใช้ที่ซ่อนอยู่",
  "column.notifications": "การแจ้งเตือน",
  "column.pins": "โพสต์ที่ปักหมุด",
  "column.public": "เส้นเวลาที่ติดต่อกับภายนอก",
  "column_back_button.label": "ย้อนกลับ",
  "column_header.hide_settings": "ซ่อนการตั้งค่า",
  "column_header.moveLeft_settings": "ย้ายคอลัมน์ไปทางซ้าย",
  "column_header.moveRight_settings": "ย้ายคอลัมน์ไปทางขวา",
  "column_header.pin": "ปักหมุด",
  "column_header.show_settings": "แสดงการตั้งค่า",
  "column_header.unpin": "ถอนหมุด",
  "column_search.cancel": "ยกเลิก",
  "community.column_settings.local_only": "ในเซิร์ฟเวอร์เท่านั้น",
  "community.column_settings.media_only": "สื่อเท่านั้น",
  "community.column_settings.remote_only": "ระยะไกลเท่านั้น",
  "compose.language.change": "เปลี่ยนภาษา",
  "compose.language.search": "ค้นหาภาษา...",
  "compose.published.body": "เผยแพร่โพสต์แล้ว",
  "compose.published.open": "เปิด",
  "compose.saved.body": "บันทึกโพสต์แล้ว",
  "compose_form.direct_message_warning_learn_more": "เรียนรู้เพิ่มเติม",
  "compose_form.encryption_warning": "โพสต์ใน Mastodon ไม่ได้เข้ารหัสแบบต้นทางถึงปลายทาง อย่าแบ่งปันข้อมูลที่ละเอียดอ่อนใด ๆ ผ่าน Mastodon",
  "compose_form.hashtag_warning": "จะไม่แสดงรายการโพสต์นี้ภายใต้แฮชแท็กใด ๆ เนื่องจากโพสต์ไม่เป็นสาธารณะ เฉพาะโพสต์สาธารณะเท่านั้นที่สามารถค้นหาได้โดยแฮชแท็ก",
  "compose_form.lock_disclaimer": "บัญชีของคุณไม่ได้ {locked} ใครก็ตามสามารถติดตามคุณเพื่อดูโพสต์สำหรับผู้ติดตามเท่านั้นของคุณ",
  "compose_form.lock_disclaimer.lock": "ล็อคอยู่",
  "compose_form.placeholder": "คุณกำลังคิดอะไรอยู่?",
  "compose_form.poll.duration": "ระยะเวลาการสำรวจความคิดเห็น",
  "compose_form.poll.multiple": "หลายตัวเลือก",
  "compose_form.poll.option_placeholder": "ตัวเลือก {number}",
  "compose_form.poll.single": "ตัวเลือกเดียว",
  "compose_form.poll.switch_to_multiple": "เปลี่ยนการสำรวจความคิดเห็นเป็นอนุญาตหลายตัวเลือก",
  "compose_form.poll.switch_to_single": "เปลี่ยนการสำรวจความคิดเห็นเป็นอนุญาตตัวเลือกเดียว",
  "compose_form.poll.type": "ลักษณะ",
  "compose_form.publish": "โพสต์",
  "compose_form.reply": "ตอบกลับ",
  "compose_form.save_changes": "อัปเดต",
  "compose_form.spoiler.marked": "เอาคำเตือนเนื้อหาออก",
  "compose_form.spoiler.unmarked": "เพิ่มคำเตือนเนื้อหา",
  "compose_form.spoiler_placeholder": "คำเตือนเนื้อหา (ไม่จำเป็น)",
  "confirmation_modal.cancel": "ยกเลิก",
  "confirmations.block.confirm": "ปิดกั้น",
  "confirmations.delete.confirm": "ลบ",
  "confirmations.delete.message": "คุณแน่ใจหรือไม่ว่าต้องการลบโพสต์นี้?",
  "confirmations.delete.title": "ลบโพสต์?",
  "confirmations.delete_list.confirm": "ลบ",
  "confirmations.delete_list.message": "คุณแน่ใจหรือไม่ว่าต้องการลบรายการนี้อย่างถาวร?",
  "confirmations.delete_list.title": "ลบรายการ?",
  "confirmations.discard_draft.confirm": "ละทิ้งและดำเนินการต่อ",
  "confirmations.discard_draft.post.title": "ละทิ้งโพสต์แบบร่างของคุณ?",
  "confirmations.discard_edit_media.confirm": "ละทิ้ง",
  "confirmations.discard_edit_media.message": "คุณมีการเปลี่ยนแปลงคำอธิบายหรือตัวอย่างสื่อที่ยังไม่ได้บันทึก ละทิ้งการเปลี่ยนแปลงเหล่านั้นต่อไป?",
  "confirmations.follow_to_list.confirm": "ติดตามและเพิ่มไปยังรายการ",
  "confirmations.follow_to_list.message": "คุณต้องติดตาม {name} ถึงจะสามารถเพิ่มพวกเขาลงลิสต์ได้",
  "confirmations.follow_to_list.title": "ติดตามผู้ใช้?",
  "confirmations.logout.confirm": "ออกจากระบบ",
  "confirmations.logout.message": "คุณแน่ใจหรือไม่ว่าต้องการออกจากระบบ?",
  "confirmations.logout.title": "ออกจากระบบ?",
  "confirmations.missing_alt_text.confirm": "เพิ่มข้อความแสดงแทน",
  "confirmations.missing_alt_text.message": "โพสต์ของคุณมีสื่อที่ไม่มีข้อความแสดงแทน การเพิ่มคำอธิบายช่วยทำให้เนื้อหาของคุณเข้าถึงผู้คนได้มากขึ้น",
  "confirmations.missing_alt_text.secondary": "โพสต์ต่อไป",
  "confirmations.missing_alt_text.title": "เพิ่มข้อความแสดงแทน?",
  "confirmations.mute.confirm": "ซ่อน",
  "confirmations.private_quote_notify.confirm": "เผยแพร่โพสต์",
  "confirmations.private_quote_notify.message": "คนที่คุณอ้างอิงและผู้ที่ถูกกล่าวถึงคนอื่น ๆ จะถูกแจ้งให้ทราบและพวกเขาจะสามารถดูโพสต์ของคุณได้ ถึงแม้พวกเขาจะไม่ได้ติดตามคุณอยู่",
  "confirmations.private_quote_notify.title": "แชร์ให้กับผู้ติดตามและผู้ใช้ที่ถูกกล่าวถึงไหม?",
  "confirmations.quiet_post_quote_info.dismiss": "ไม่ต้องเตือนฉันอีก",
  "confirmations.quiet_post_quote_info.got_it": "เข้าใจแล้ว",
  "confirmations.redraft.confirm": "ลบแล้วร่างใหม่",
  "confirmations.redraft.message": "คุณแน่ใจหรือไม่ว่าต้องการลบโพสต์นี้แล้วร่างโพสต์ใหม่? รายการโปรดและการดันจะสูญหาย และการตอบกลับโพสต์ดั้งเดิมจะไม่มีความเกี่ยวพัน",
  "confirmations.redraft.title": "ลบแล้วร่างโพสต์ใหม่?",
  "confirmations.remove_from_followers.confirm": "เอาผู้ติดตามออก",
  "confirmations.remove_from_followers.message": "{name} จะหยุดติดตามคุณ คุณแน่ใจไหมว่าจะดำเนินการต่อ",
  "confirmations.remove_from_followers.title": "เอาผู้ติดตามออก?",
  "confirmations.revoke_quote.confirm": "เอาโพสต์ออก",
  "confirmations.revoke_quote.title": "เอาโพสต์ออก?",
  "confirmations.unblock.confirm": "เลิกปิดกั้น",
  "confirmations.unblock.title": "เลิกปิดกั้น {name}?",
  "confirmations.unfollow.confirm": "เลิกติดตาม",
  "confirmations.unfollow.title": "เลิกติดตาม {name}?",
  "confirmations.withdraw_request.confirm": "ถอนคำขอ",
  "content_warning.hide": "ซ่อนโพสต์",
  "content_warning.show": "แสดงต่อไป",
  "content_warning.show_more": "แสดงเพิ่มเติม",
  "conversation.delete": "ลบการสนทนา",
  "conversation.mark_as_read": "ทำเครื่องหมายว่าอ่านแล้ว",
  "conversation.open": "ดูการสนทนา",
  "conversation.with": "กับ {names}",
  "copy_icon_button.copied": "คัดลอกไปยังคลิปบอร์ดแล้ว",
  "copypaste.copied": "คัดลอกแล้ว",
  "copypaste.copy_to_clipboard": "คัดลอกไปยังคลิปบอร์ด",
  "custom_homepage.latest_activity": "กิจกรรมล่าสุด",
  "directory.federated": "จากจักรวาลสหพันธ์ที่รู้จัก",
  "directory.local": "จาก {domain} เท่านั้น",
  "directory.new_arrivals": "มาใหม่",
  "directory.recently_active": "ใช้งานล่าสุด",
  "disabled_account_banner.account_settings": "การตั้งค่าบัญชี",
  "disabled_account_banner.text": "มีการปิดใช้งานบัญชีของคุณ {disabledAccount} ในปัจจุบัน",
  "dismissable_banner.community_timeline": "นี่คือโพสต์สาธารณะล่าสุดจากผู้คนที่บัญชีได้รับการโฮสต์โดย {domain}",
  "dismissable_banner.dismiss": "ปิด",
  "domain_block_modal.block": "ปิดกั้นเซิร์ฟเวอร์",
  "domain_block_modal.block_account_instead": "ปิดกั้น @{name} แทน",
  "domain_block_modal.they_can_interact_with_old_posts": "ผู้คนจากเซิร์ฟเวอร์นี้สามารถโต้ตอบกับโพสต์เก่า ๆ ของคุณ",
  "domain_block_modal.they_cant_follow": "ไม่มีใครจากเซิร์ฟเวอร์นี้สามารถติดตามคุณ",
  "domain_block_modal.they_wont_know": "เขาจะไม่ทราบว่ามีการปิดกั้นเขา",
  "domain_block_modal.title": "ปิดกั้นโดเมน?",
  "domain_block_modal.you_will_lose_num_followers": "คุณจะสูญเสีย {followersCount, plural, other {{followersCountDisplay} ผู้ติดตาม}}และ {followingCount, plural, other {{followingCountDisplay} คนที่คุณติดตาม}}",
  "domain_block_modal.you_will_lose_relationships": "คุณจะสูญเสียผู้ติดตามและผู้คนที่คุณติดตามทั้งหมดจากเซิร์ฟเวอร์นี้",
  "domain_block_modal.you_wont_see_posts": "คุณจะไม่เห็นโพสต์หรือการแจ้งเตือนจากผู้ใช้ในเซิร์ฟเวอร์นี้",
  "dropdown.empty": "เลือกตัวเลือก",
  "embed.instructions": "ฝังโพสต์นี้ในเว็บไซต์ของคุณโดยคัดลอกโค้ดด้านล่าง",
  "embed.preview": "นี่คือลักษณะของการฝังที่จะปรากฏ:",
  "emoji_button.activity": "กิจกรรม",
  "emoji_button.clear": "ล้าง",
  "emoji_button.custom": "กำหนดเอง",
  "emoji_button.flags": "ธง",
  "emoji_button.food": "อาหารและเครื่องดื่ม",
  "emoji_button.label": "แทรกอีโมจิ",
  "emoji_button.nature": "ธรรมชาติ",
  "emoji_button.not_found": "ไม่พบอีโมจิที่ตรงกัน",
  "emoji_button.objects": "วัตถุ",
  "emoji_button.people": "ผู้คน",
  "emoji_button.recent": "ที่ใช้บ่อย",
  "emoji_button.search": "ค้นหา...",
  "emoji_button.search_results": "ผลลัพธ์การค้นหา",
  "emoji_button.symbols": "สัญลักษณ์",
  "emoji_button.travel": "การเดินทางและสถานที่",
  "empty_column.account_hides_collections": "ผู้ใช้นี้ได้เลือกที่จะไม่ทำให้ข้อมูลนี้พร้อมใช้งาน",
  "empty_column.account_suspended": "ระงับบัญชีอยู่",
  "empty_column.account_timeline": "ไม่มีโพสต์ที่นี่!",
  "empty_column.account_unavailable": "โปรไฟล์ไม่พร้อมใช้งาน",
  "empty_column.blocks": "คุณยังไม่ได้ปิดกั้นผู้ใช้ใด ๆ",
  "empty_column.bookmarked_statuses": "คุณยังไม่มีโพสต์ที่เพิ่มที่คั่นหน้าไว้ใด ๆ เมื่อคุณเพิ่มที่คั่นหน้าโพสต์ โพสต์จะปรากฏที่นี่",
  "empty_column.community": "เส้นเวลาในเซิร์ฟเวอร์ว่างเปล่า เขียนบางอย่างเป็นสาธารณะเพื่อเริ่มต้น!",
  "empty_column.direct": "คุณยังไม่มีการกล่าวถึงแบบส่วนตัวใด ๆ เมื่อคุณส่งหรือรับการกล่าวถึง การกล่าวถึงจะปรากฏที่นี่",
  "empty_column.domain_blocks": "ยังไม่มีโดเมนที่ปิดกั้นอยู่",
  "empty_column.explore_statuses": "ไม่มีสิ่งใดที่กำลังนิยมในตอนนี้ กลับมาตรวจสอบในภายหลัง!",
  "empty_column.favourited_statuses": "คุณยังไม่มีโพสต์ที่ชื่นชอบใด ๆ เมื่อคุณชื่นชอบโพสต์ โพสต์จะปรากฏที่นี่",
  "empty_column.favourites": "ยังไม่มีใครชื่นชอบโพสต์นี้ เมื่อใครสักคนชื่นชอบ เขาจะปรากฏที่นี่",
  "empty_column.follow_requests": "คุณยังไม่มีคำขอติดตามใด ๆ เมื่อคุณได้รับคำขอ คำขอจะปรากฏที่นี่",
  "empty_column.followed_tags": "คุณยังไม่ได้ติดตามแฮชแท็กใด ๆ เมื่อคุณติดตาม แฮชแท็กจะปรากฏที่นี่",
  "empty_column.hashtag": "ยังไม่มีสิ่งใดในแฮชแท็กนี้",
  "empty_column.home": "เส้นเวลาหน้าแรกของคุณว่างเปล่า! ติดตามผู้คนเพิ่มเติมเพื่อเติมเส้นเวลาให้เต็ม",
  "empty_column.list": "ยังไม่มีสิ่งใดในรายการนี้ เมื่อสมาชิกของรายการนี้โพสต์โพสต์ใหม่ โพสต์จะปรากฏที่นี่",
  "empty_column.mutes": "คุณยังไม่ได้ซ่อนผู้ใช้ใด ๆ",
  "empty_column.notification_requests": "โล่งทั้งหมด! ไม่มีสิ่งใดที่นี่ เมื่อคุณได้รับการแจ้งเตือนใหม่ การแจ้งเตือนจะปรากฏที่นี่ตามการตั้งค่าของคุณ",
  "empty_column.notifications": "คุณยังไม่มีการแจ้งเตือนใด ๆ เมื่อผู้คนอื่น ๆ โต้ตอบกับคุณ คุณจะเห็นการแจ้งเตือนที่นี่",
  "empty_column.public": "ไม่มีสิ่งใดที่นี่! เขียนบางอย่างเป็นสาธารณะ หรือติดตามผู้ใช้จากเซิร์ฟเวอร์อื่น ๆ ด้วยตนเองเพื่อเติมเส้นเวลาให้เต็ม",
  "error.no_hashtag_feed_access": "ลงทะเบียนหรือลงชื่อเข้าใช้เพื่อดูและติดตามแฮชแท็กนี้",
  "error.unexpected_crash.explanation": "เนื่องจากข้อบกพร่องในโค้ดของเราหรือปัญหาความเข้ากันได้ของเบราว์เซอร์ จึงไม่สามารถแสดงหน้านี้ได้อย่างถูกต้อง",
  "error.unexpected_crash.explanation_addons": "ไม่สามารถแสดงหน้านี้ได้อย่างถูกต้อง ข้อผิดพลาดนี้มีแนวโน้มว่าเกิดจากส่วนเสริมของเบราว์เซอร์หรือเครื่องมือการแปลอัตโนมัติ",
  "error.unexpected_crash.next_steps": "ลองรีเฟรชหน้า หากนั่นไม่ช่วย คุณอาจยังสามารถใช้ Mastodon ได้ผ่านเบราว์เซอร์อื่นหรือแอปเนทีฟ",
  "error.unexpected_crash.next_steps_addons": "ลองปิดใช้งานส่วนเสริมหรือเครื่องมือเหล่านั้นและรีเฟรชหน้า หากนั่นไม่ช่วย คุณอาจยังสามารถใช้ Mastodon ได้ผ่านเบราว์เซอร์อื่นหรือแอปเนทีฟ",
  "errors.unexpected_crash.copy_stacktrace": "คัดลอกการติดตามสแตกไปยังคลิปบอร์ด",
  "errors.unexpected_crash.report_issue": "รายงานปัญหา",
  "explore.suggested_follows": "ผู้คน",
  "explore.title": "กำลังนิยม",
  "explore.trending_links": "ข่าว",
  "explore.trending_statuses": "โพสต์",
  "explore.trending_tags": "แฮชแท็ก",
  "featured_carousel.current": "<sr>โพสต์</sr> {current, number} / {max, number}",
  "featured_carousel.header": "{count, plural, other {โพสต์ที่ปักหมุด}}",
  "featured_carousel.slide": "โพสต์ {current, number} จาก {max, number}",
  "filter_modal.added.context_mismatch_explanation": "หมวดหมู่ตัวกรองนี้ไม่นำไปใช้กับบริบทที่คุณได้เข้าถึงโพสต์นี้ หากคุณต้องการกรองโพสต์ในบริบทนี้ด้วย คุณจะต้องแก้ไขตัวกรอง",
  "filter_modal.added.context_mismatch_title": "บริบทไม่ตรงกัน!",
  "filter_modal.added.expired_explanation": "หมวดหมู่ตัวกรองนี้หมดอายุแล้ว คุณจะต้องเปลี่ยนวันหมดอายุสำหรับหมวดหมู่เพื่อนำไปใช้",
  "filter_modal.added.expired_title": "ตัวกรองหมดอายุแล้ว!",
  "filter_modal.added.review_and_configure": "เพื่อตรวจทานและกำหนดค่าหมวดหมู่ตัวกรองนี้เพิ่มเติม ไปยัง {settings_link}",
  "filter_modal.added.review_and_configure_title": "การตั้งค่าตัวกรอง",
  "filter_modal.added.settings_link": "หน้าการตั้งค่า",
  "filter_modal.added.short_explanation": "เพิ่มโพสต์นี้ไปยังหมวดหมู่ตัวกรองดังต่อไปนี้แล้ว: {title}",
  "filter_modal.added.title": "เพิ่มตัวกรองแล้ว!",
  "filter_modal.select_filter.context_mismatch": "ไม่นำไปใช้กับบริบทนี้",
  "filter_modal.select_filter.expired": "หมดอายุแล้ว",
  "filter_modal.select_filter.prompt_new": "หมวดหมู่ใหม่: {name}",
  "filter_modal.select_filter.search": "ค้นหาหรือสร้าง",
  "filter_modal.select_filter.subtitle": "ใช้หมวดหมู่ที่มีอยู่หรือสร้างหมวดหมู่ใหม่",
  "filter_modal.select_filter.title": "กรองโพสต์นี้",
  "filter_modal.title.status": "กรองโพสต์",
  "filter_warning.matches_filter": "ตรงกับตัวกรอง “<span>{title}</span>”",
  "filtered_notifications_banner.pending_requests": "จาก {count, plural, =0 {ไม่มีใคร} other {# คน}} ที่คุณอาจรู้จัก",
  "filtered_notifications_banner.title": "การแจ้งเตือนที่กรองอยู่",
  "firehose.all": "ทั้งหมด",
  "firehose.local": "เซิร์ฟเวอร์นี้",
  "firehose.remote": "เซิร์ฟเวอร์อื่น ๆ",
  "follow_request.authorize": "อนุญาต",
  "follow_request.reject": "ปฏิเสธ",
  "follow_requests.unlocked_explanation": "แม้ว่าไม่มีการล็อคบัญชีของคุณ พนักงานของ {domain} คิดว่าคุณอาจต้องการตรวจทานคำขอติดตามจากบัญชีเหล่านี้ด้วยตนเอง",
  "follow_suggestions.curated_suggestion": "คัดสรรโดยพนักงาน",
  "follow_suggestions.dismiss": "ไม่ต้องแสดงอีก",
  "follow_suggestions.featured_longer": "คัดสรรโดยทีม {domain}",
  "follow_suggestions.friends_of_friends_longer": "เป็นที่นิยมในหมู่ผู้คนที่คุณติดตาม",
  "follow_suggestions.hints.featured": "โปรไฟล์นี้ได้รับการคัดสรรโดยทีม {domain}",
  "follow_suggestions.hints.friends_of_friends": "โปรไฟล์นี้เป็นที่นิยมในหมู่ผู้คนที่คุณติดตาม",
  "follow_suggestions.hints.most_followed": "โปรไฟล์นี้เป็นหนึ่งในโปรไฟล์ที่ได้รับการติดตามมากที่สุดใน {domain}",
  "follow_suggestions.hints.most_interactions": "โปรไฟล์นี้เพิ่งได้รับความสนใจอย่างมากใน {domain}",
  "follow_suggestions.hints.similar_to_recently_followed": "โปรไฟล์นี้คล้ายกับโปรไฟล์ที่คุณได้ติดตามล่าสุด",
  "follow_suggestions.personalized_suggestion": "ข้อเสนอแนะเฉพาะบุคคล",
  "follow_suggestions.popular_suggestion": "ข้อเสนอแนะยอดนิยม",
  "follow_suggestions.popular_suggestion_longer": "เป็นที่นิยมใน {domain}",
  "follow_suggestions.similar_to_recently_followed_longer": "คล้ายกับโปรไฟล์ที่คุณได้ติดตามล่าสุด",
  "follow_suggestions.view_all": "ดูทั้งหมด",
  "follow_suggestions.who_to_follow": "ติดตามใครดี",
  "followed_tags": "แฮชแท็กที่ติดตาม",
  "followers.hide_other_followers": "ผู้ใช้นี้เลือกที่จะไม่แสดงรายชื่อผู้ติดตามคนอื่น ๆ ของพวกเขา",
  "following.hide_other_following": "ผู้ใช้นี้เลือกที่จะไม่แสดงรายชื่อคนอื่น ๆ ที่พวกเขาติดตาม",
  "footer.about": "เกี่ยวกับ",
  "footer.about_this_server": "เกี่ยวกับ",
  "footer.directory": "ไดเรกทอรีโปรไฟล์",
  "footer.get_app": "รับแอป",
  "footer.keyboard_shortcuts": "แป้นพิมพ์ลัด",
  "footer.privacy_policy": "นโยบายความเป็นส่วนตัว",
  "footer.source_code": "ดูโค้ดต้นฉบับ",
  "footer.status": "สถานะ",
  "footer.terms_of_service": "เงื่อนไขการให้บริการ",
  "getting_started.heading": "เริ่มต้นใช้งาน",
  "hashtag.admin_moderation": "เปิดส่วนติดต่อการกลั่นกรองสำหรับ #{name}",
  "hashtag.browse": "เรียกดูโพสต์ใน #{hashtag}",
  "hashtag.browse_from_account": "เรียกดูโพสต์จาก @{name} ใน #{hashtag}",
  "hashtag.column_header.tag_mode.all": "และ {additional}",
  "hashtag.column_header.tag_mode.any": "หรือ {additional}",
  "hashtag.column_header.tag_mode.none": "โดยไม่มี {additional}",
  "hashtag.column_settings.select.no_options_message": "ไม่พบข้อเสนอแนะ",
  "hashtag.column_settings.select.placeholder": "ป้อนแฮชแท็ก…",
  "hashtag.column_settings.tag_mode.all": "ทั้งหมดนี้",
  "hashtag.column_settings.tag_mode.any": "ใดก็ตามนี้",
  "hashtag.column_settings.tag_mode.none": "ไม่ใช่ทั้งหมดนี้",
  "hashtag.column_settings.tag_toggle": "รวมแท็กเพิ่มเติมสำหรับคอลัมน์นี้",
  "hashtag.counter_by_accounts": "{count, plural, other {{counter} ผู้มีส่วนร่วม}}",
  "hashtag.counter_by_uses": "{count, plural, other {{counter} โพสต์}}",
  "hashtag.counter_by_uses_today": "{count, plural, other {{counter} โพสต์}}วันนี้",
  "hashtag.feature": "แสดงในโปรไฟล์",
  "hashtag.follow": "ติดตามแฮชแท็ก",
  "hashtag.mute": "ซ่อน #{hashtag}",
  "hashtag.unfeature": "ไม่แสดงในโปรไฟล์",
  "hashtag.unfollow": "เลิกติดตามแฮชแท็ก",
  "hashtags.and_other": "…และอีก {count, plural, other {# เพิ่มเติม}}",
  "hints.profiles.followers_may_be_missing": "ผู้ติดตามสำหรับโปรไฟล์นี้อาจขาดหายไป",
  "hints.profiles.follows_may_be_missing": "การติดตามสำหรับโปรไฟล์นี้อาจขาดหายไป",
  "hints.profiles.posts_may_be_missing": "โพสต์บางส่วนจากโปรไฟล์นี้อาจขาดหายไป",
  "hints.profiles.see_more_followers": "ดูผู้ติดตามเพิ่มเติมใน {domain}",
  "hints.profiles.see_more_follows": "ดูการติดตามเพิ่มเติมใน {domain}",
  "hints.profiles.see_more_posts": "ดูโพสต์เพิ่มเติมใน {domain}",
  "home.column_settings.show_quotes": "แสดงการอ้างอิง",
  "home.column_settings.show_reblogs": "แสดงการดัน",
  "home.column_settings.show_replies": "แสดงการตอบกลับ",
  "home.hide_announcements": "ซ่อนประกาศ",
  "home.pending_critical_update.body": "โปรดอัปเดตเซิร์ฟเวอร์ Mastodon ของคุณโดยเร็วที่สุดเท่าที่จะเป็นไปได้!",
  "home.pending_critical_update.link": "ดูการอัปเดต",
  "home.pending_critical_update.title": "มีการอัปเดตความปลอดภัยสำคัญพร้อมใช้งาน!",
  "home.show_announcements": "แสดงประกาศ",
  "ignore_notifications_modal.disclaimer": "Mastodon ไม่สามารถแจ้งผู้ใช้ว่าคุณได้เพิกเฉยการแจ้งเตือนของเขา การเพิกเฉยการแจ้งเตือนจะไม่หยุดการส่งข้อความนั้นเอง",
  "ignore_notifications_modal.filter_instead": "กรองแทน",
  "ignore_notifications_modal.filter_to_act_users": "คุณจะยังสามารถยอมรับ ปฏิเสธ หรือรายงานผู้ใช้",
  "ignore_notifications_modal.filter_to_avoid_confusion": "การกรองช่วยหลีกเลี่ยงความสับสนที่อาจเกิดขึ้น",
  "ignore_notifications_modal.filter_to_review_separately": "คุณสามารถตรวจทานการแจ้งเตือนที่กรองอยู่แยกต่างหาก",
  "ignore_notifications_modal.ignore": "เพิกเฉยการแจ้งเตือน",
  "ignore_notifications_modal.limited_accounts_title": "เพิกเฉยการแจ้งเตือนจากบัญชีที่ได้รับการกลั่นกรอง?",
  "ignore_notifications_modal.new_accounts_title": "เพิกเฉยการแจ้งเตือนจากบัญชีใหม่?",
  "ignore_notifications_modal.not_followers_title": "เพิกเฉยการแจ้งเตือนจากผู้คนที่ไม่ได้ติดตามคุณ?",
  "ignore_notifications_modal.not_following_title": "เพิกเฉยการแจ้งเตือนจากผู้คนที่คุณไม่ได้ติดตาม?",
  "ignore_notifications_modal.private_mentions_title": "เพิกเฉยการแจ้งเตือนจากการกล่าวถึงแบบส่วนตัวที่ไม่พึงประสงค์?",
  "info_button.label": "ช่วยเหลือ",
  "interaction_modal.go": "ไป",
  "interaction_modal.no_account_yet": "ยังไม่มีบัญชี?",
  "interaction_modal.on_another_server": "ในเซิร์ฟเวอร์อื่น",
  "interaction_modal.on_this_server": "ในเซิร์ฟเวอร์นี้",
  "interaction_modal.title": "ลงชื่อเข้าเพื่อดำเนินการต่อ",
  "interaction_modal.username_prompt": "เช่น {example}",
  "intervals.full.days": "{number, plural, other {# วัน}}",
  "intervals.full.hours": "{number, plural, other {# ชั่วโมง}}",
  "intervals.full.minutes": "{number, plural, other {# นาที}}",
  "keyboard_shortcuts.back": "นำทางย้อนกลับ",
  "keyboard_shortcuts.blocked": "เปิดรายการผู้ใช้ที่ปิดกั้นอยู่",
  "keyboard_shortcuts.boost": "ดันโพสต์",
  "keyboard_shortcuts.column": "โฟกัสคอลัมน์",
  "keyboard_shortcuts.compose": "โฟกัสพื้นที่เขียนข้อความ",
  "keyboard_shortcuts.description": "คำอธิบาย",
  "keyboard_shortcuts.down": "ย้ายลงในรายการ",
  "keyboard_shortcuts.enter": "เปิดโพสต์",
  "keyboard_shortcuts.favourite": "ชื่นชอบโพสต์",
  "keyboard_shortcuts.favourites": "เปิดรายการโปรด",
  "keyboard_shortcuts.federated": "เปิดเส้นเวลาที่ติดต่อกับภายนอก",
  "keyboard_shortcuts.heading": "แป้นพิมพ์ลัด",
  "keyboard_shortcuts.home": "เปิดเส้นเวลาหน้าแรก",
  "keyboard_shortcuts.hotkey": "ปุ่มลัด",
  "keyboard_shortcuts.legend": "แสดงคำอธิบายนี้",
  "keyboard_shortcuts.load_more": "โฟกัสปุ่ม \"โหลดเพิ่มเติม\"",
  "keyboard_shortcuts.local": "เปิดเส้นเวลาในเซิร์ฟเวอร์",
  "keyboard_shortcuts.mention": "กล่าวถึงผู้สร้าง",
  "keyboard_shortcuts.muted": "เปิดรายการผู้ใช้ที่ซ่อนอยู่",
  "keyboard_shortcuts.my_profile": "เปิดโปรไฟล์ของคุณ",
  "keyboard_shortcuts.notifications": "เปิดคอลัมน์การแจ้งเตือน",
  "keyboard_shortcuts.open_media": "เปิดสื่อ",
  "keyboard_shortcuts.pinned": "เปิดรายการโพสต์ที่ปักหมุด",
  "keyboard_shortcuts.profile": "เปิดโปรไฟล์ของผู้สร้าง",
  "keyboard_shortcuts.quote": "อ้างอิงโพสต์",
  "keyboard_shortcuts.reply": "ตอบกลับโพสต์",
  "keyboard_shortcuts.requests": "เปิดรายการคำขอติดตาม",
  "keyboard_shortcuts.search": "โฟกัสแถบค้นหา",
  "keyboard_shortcuts.spoilers": "แสดง/ซ่อนช่องกรอกคำเตือนเนื้อหา",
  "keyboard_shortcuts.start": "เปิดคอลัมน์ “เริ่มต้นใช้งาน”",
  "keyboard_shortcuts.toggle_hidden": "แสดง/ซ่อนข้อความที่อยู่หลังคำเตือนเนื้อหา",
  "keyboard_shortcuts.toggle_sensitivity": "แสดง/ซ่อนสื่อ",
  "keyboard_shortcuts.toot": "เริ่มโพสต์ใหม่",
  "keyboard_shortcuts.unfocus": "เลิกโฟกัสพื้นที่เขียนข้อความ/การค้นหา",
  "keyboard_shortcuts.up": "ย้ายขึ้นในรายการ",
  "learn_more_link.got_it": "เข้าใจแล้ว",
  "learn_more_link.learn_more": "เรียนรู้เพิ่มเติม",
  "lightbox.close": "ปิด",
  "lightbox.next": "ถัดไป",
  "lightbox.previous": "ก่อนหน้า",
  "lightbox.zoom_in": "ซูมเป็นขนาดจริง",
  "lightbox.zoom_out": "ซูมให้พอดี",
  "limited_account_hint.action": "แสดงโปรไฟล์ต่อไป",
  "link_preview.author": "โดย {name}",
  "link_preview.more_from_author": "เพิ่มเติมจาก {name}",
  "link_preview.shares": "{count, plural, other {{counter} โพสต์}}",
  "lists.add_member": "เพิ่ม",
  "lists.add_to_list": "เพิ่มไปยังรายการ",
  "lists.add_to_lists": "เพิ่ม {name} ไปยังรายการ",
  "lists.create": "สร้าง",
  "lists.create_a_list_to_organize": "สร้างรายการใหม่เพื่อจัดระเบียบฟีดหน้าแรกของคุณ",
  "lists.create_list": "สร้างรายการ",
  "lists.delete": "ลบรายการ",
  "lists.done": "เสร็จสิ้น",
  "lists.edit": "แก้ไขรายการ",
  "lists.exclusive": "ซ่อนสมาชิกในหน้าแรก",
  "lists.exclusive_hint": "หากใครสักคนอยู่ในรายการนี้ ให้ซ่อนเขาในฟีดหน้าแรกของคุณเพื่อหลีกเลี่ยงการเห็นโพสต์ของเขาสองครั้ง",
  "lists.find_users_to_add": "ค้นหาผู้ใช้ที่จะเพิ่ม",
  "lists.list_members_count": "{count, plural, other {# สมาชิก}}",
  "lists.list_name": "ชื่อรายการ",
  "lists.new_list_name": "ชื่อรายการใหม่",
  "lists.no_lists_yet": "ยังไม่มีรายการ",
  "lists.no_members_yet": "ยังไม่มีสมาชิก",
  "lists.no_results_found": "ไม่พบผลลัพธ์",
  "lists.remove_member": "เอาออก",
  "lists.replies_policy.followed": "ผู้ใช้ใด ๆ ที่ติดตาม",
  "lists.replies_policy.list": "สมาชิกของรายการ",
  "lists.replies_policy.none": "ไม่มีใคร",
  "lists.save": "บันทึก",
  "lists.search": "ค้นหา",
  "lists.show_replies_to": "รวมการตอบกลับจากสมาชิกของรายการถึง",
  "load_pending": "{count, plural, other {# รายการใหม่}}",
  "loading_indicator.label": "กำลังโหลด…",
  "media_gallery.hide": "ซ่อน",
  "moved_to_account_banner.text": "มีการปิดใช้งานบัญชีของคุณ {disabledAccount} ในปัจจุบันเนื่องจากคุณได้ย้ายไปยัง {movedToAccount}",
  "mute_modal.hide_from_notifications": "ซ่อนจากการแจ้งเตือน",
  "mute_modal.hide_options": "ซ่อนตัวเลือก",
  "mute_modal.indefinite": "จนกว่าฉันจะเลิกซ่อนเขา",
  "mute_modal.show_options": "แสดงตัวเลือก",
  "mute_modal.they_can_mention_and_follow": "เขาสามารถกล่าวถึงและติดตามคุณ แต่คุณจะไม่เห็นเขา",
  "mute_modal.they_wont_know": "เขาจะไม่ทราบว่ามีการซ่อนเขา",
  "mute_modal.title": "ซ่อนผู้ใช้?",
  "mute_modal.you_wont_see_mentions": "คุณจะไม่เห็นโพสต์ที่กล่าวถึงเขา",
  "mute_modal.you_wont_see_posts": "เขายังคงสามารถเห็นโพสต์ของคุณ แต่คุณจะไม่เห็นโพสต์ของเขา",
  "navigation_bar.about": "เกี่ยวกับ",
  "navigation_bar.account_settings": "รหัสผ่านและความปลอดภัย",
  "navigation_bar.administration": "การดูแล",
  "navigation_bar.advanced_interface": "เปิดในส่วนติดต่อเว็บขั้นสูง",
  "navigation_bar.automated_deletion": "การลบโพสต์แบบอัตโนมัติ",
  "navigation_bar.blocks": "ผู้ใช้ที่ปิดกั้นอยู่",
  "navigation_bar.bookmarks": "ที่คั่นหน้า",
  "navigation_bar.direct": "การกล่าวถึงแบบส่วนตัว",
  "navigation_bar.domain_blocks": "โดเมนที่ปิดกั้นอยู่",
  "navigation_bar.favourites": "รายการโปรด",
  "navigation_bar.filters": "คำที่ซ่อนอยู่",
  "navigation_bar.follow_requests": "คำขอติดตาม",
  "navigation_bar.followed_tags": "แฮชแท็กที่ติดตาม",
  "navigation_bar.follows_and_followers": "การติดตามและผู้ติดตาม",
  "navigation_bar.import_export": "การนำเข้าและการส่งออก",
  "navigation_bar.lists": "รายการ",
  "navigation_bar.live_feed_local": "ฟีดสด (ในเซิร์ฟเวอร์)",
  "navigation_bar.live_feed_public": "ฟีดสด (สาธารณะ)",
  "navigation_bar.logout": "ออกจากระบบ",
  "navigation_bar.moderation": "การกลั่นกรอง",
  "navigation_bar.more": "เพิ่มเติม",
  "navigation_bar.mutes": "ผู้ใช้ที่ซ่อนอยู่",
  "navigation_bar.opened_in_classic_interface": "จะเปิดโพสต์, บัญชี และหน้าที่เฉพาะเจาะจงอื่น ๆ เป็นค่าเริ่มต้นในส่วนติดต่อเว็บแบบคลาสสิก",
  "navigation_bar.preferences": "การกำหนดลักษณะ",
  "navigation_bar.privacy_and_reach": "ความเป็นส่วนตัวและการเข้าถึง",
  "navigation_bar.search": "ค้นหา",
  "navigation_bar.search_trends": "ค้นหา / กำลังนิยม",
  "navigation_panel.collapse_followed_tags": "ยุบเมนูแฮชแท็กที่ติดตามอยู่",
  "navigation_panel.collapse_lists": "ยุบเมนูรายการ",
  "navigation_panel.expand_followed_tags": "ขยายเมนูแฮชแท็กที่ติดตามอยู่",
  "navigation_panel.expand_lists": "ขยายเมนูรายการ",
  "not_signed_in_indicator.not_signed_in": "คุณจำเป็นต้องเข้าสู่ระบบเพื่อเข้าถึงทรัพยากรนี้",
  "notification.admin.report": "{name} ได้รายงาน {target}",
  "notification.admin.report_account": "{name} ได้รายงาน {count, plural, other {# โพสต์}}จาก {target} สำหรับ {category}",
  "notification.admin.report_account_other": "{name} ได้รายงาน {count, plural, other {# โพสต์}}จาก {target}",
  "notification.admin.report_statuses": "{name} ได้รายงาน {target} สำหรับ {category}",
  "notification.admin.report_statuses_other": "{name} ได้รายงาน {target}",
  "notification.admin.sign_up": "{name} ได้ลงทะเบียน",
  "notification.admin.sign_up.name_and_others": "{name} และ {count, plural, other {# อื่น ๆ}} ได้ลงทะเบียน",
  "notification.annual_report.view": "ดู #Wrapstodon",
  "notification.favourite": "{name} ได้ชื่นชอบโพสต์ของคุณ",
  "notification.favourite.name_and_others_with_link": "{name} และ <a>{count, plural, other {# อื่น ๆ}}</a> ได้ชื่นชอบโพสต์ของคุณ",
  "notification.favourite_pm": "{name} ได้ชื่นชอบการกล่าวถึงแบบส่วนตัวของคุณ",
  "notification.favourite_pm.name_and_others_with_link": "{name} และ <a>{count, plural, other {# อื่น ๆ}}</a> ได้ชื่นชอบการกล่าวถึงแบบส่วนตัวของคุณ",
  "notification.follow": "{name} ได้ติดตามคุณ",
  "notification.follow.name_and_others": "{name} และ <a>{count, plural, other {# อื่น ๆ}}</a> ได้ติดตามคุณ",
  "notification.follow_request": "{name} ได้ขอติดตามคุณ",
  "notification.follow_request.name_and_others": "{name} และ {count, plural, other {# อื่น ๆ}} ได้ขอติดตามคุณ",
  "notification.label.mention": "การกล่าวถึง",
  "notification.label.private_mention": "การกล่าวถึงแบบส่วนตัว",
  "notification.label.private_reply": "การตอบกลับแบบส่วนตัว",
  "notification.label.quote": "{name} ได้อ้างอิงโพสต์ของคุณ",
  "notification.label.reply": "การตอบกลับ",
  "notification.mention": "การกล่าวถึง",
  "notification.mentioned_you": "{name} ได้กล่าวถึงคุณ",
  "notification.moderation-warning.learn_more": "เรียนรู้เพิ่มเติม",
  "notification.moderation_warning": "คุณได้รับคำเตือนการกลั่นกรอง",
  "notification.moderation_warning.action_delete_statuses": "เอาโพสต์บางส่วนของคุณออกแล้ว",
  "notification.moderation_warning.action_disable": "ปิดใช้งานบัญชีของคุณแล้ว",
  "notification.moderation_warning.action_mark_statuses_as_sensitive": "ทำเครื่องหมายโพสต์บางส่วนของคุณว่าละเอียดอ่อนแล้ว",
  "notification.moderation_warning.action_none": "บัญชีของคุณได้รับคำเตือนการกลั่นกรอง",
  "notification.moderation_warning.action_sensitive": "จะทำเครื่องหมายโพสต์ของคุณว่าละเอียดอ่อนนับจากนี้ไป",
  "notification.moderation_warning.action_silence": "จำกัดบัญชีของคุณแล้ว",
  "notification.moderation_warning.action_suspend": "ระงับบัญชีของคุณแล้ว",
  "notification.own_poll": "การสำรวจความคิดเห็นของคุณได้สิ้นสุดแล้ว",
  "notification.poll": "การสำรวจความคิดเห็นที่คุณได้ลงคะแนนได้สิ้นสุดแล้ว",
  "notification.quoted_update": "{name} ได้แก้ไขโพสต์ที่คุณได้อ้างอิง",
  "notification.reblog": "{name} ได้ดันโพสต์ของคุณ",
  "notification.reblog.name_and_others_with_link": "{name} และ <a>{count, plural, other {# อื่น ๆ}}</a> ได้ดันโพสต์ของคุณ",
  "notification.relationships_severance_event": "สูญเสียการเชื่อมต่อกับ {name}",
  "notification.relationships_severance_event.account_suspension": "ผู้ดูแลจาก {from} ได้ระงับ {target} ซึ่งหมายความว่าคุณจะไม่สามารถรับการอัปเดตจากเขาหรือโต้ตอบกับเขาได้อีกต่อไป",
  "notification.relationships_severance_event.domain_block": "ผู้ดูแลจาก {from} ได้ปิดกั้น {target} รวมถึง {followersCount} ผู้ติดตามของคุณและ {followingCount, plural, other {# บัญชี}}ที่คุณติดตาม",
  "notification.relationships_severance_event.learn_more": "เรียนรู้เพิ่มเติม",
  "notification.relationships_severance_event.user_domain_block": "คุณได้ปิดกั้น {target} เอา {followersCount} ผู้ติดตามของคุณและ {followingCount, plural, other {# บัญชี}}ที่คุณติดตามออก",
  "notification.status": "{name} เพิ่งโพสต์",
  "notification.update": "{name} ได้แก้ไขโพสต์",
  "notification_requests.accept": "ยอมรับ",
  "notification_requests.accept_multiple": "{count, plural, other {ยอมรับ # คำขอ…}}",
  "notification_requests.confirm_accept_multiple.button": "{count, plural, other {ยอมรับคำขอ}}",
  "notification_requests.confirm_accept_multiple.message": "คุณกำลังจะยอมรับ {count, plural, other {# คำขอการแจ้งเตือน}} คุณแน่ใจหรือไม่ว่าต้องการดำเนินการต่อ?",
  "notification_requests.confirm_accept_multiple.title": "ยอมรับคำขอการแจ้งเตือน?",
  "notification_requests.confirm_dismiss_multiple.button": "{count, plural, other {ปิดคำขอ}}",
  "notification_requests.confirm_dismiss_multiple.message": "คุณกำลังจะปิด {count, plural, other {# คำขอการแจ้งเตือน}} คุณจะไม่สามารถเข้าถึง{count, plural, other {การแจ้งเตือน}}ได้อย่างง่ายดายอีกครั้ง คุณแน่ใจหรือไม่ว่าต้องการดำเนินการต่อ?",
  "notification_requests.confirm_dismiss_multiple.title": "ปิดคำขอการแจ้งเตือน?",
  "notification_requests.dismiss": "ปิด",
  "notification_requests.dismiss_multiple": "{count, plural, other {ปิด # คำขอ…}}",
  "notification_requests.edit_selection": "แก้ไข",
  "notification_requests.exit_selection": "เสร็จสิ้น",
  "notification_requests.explainer_for_limited_account": "มีการกรองการแจ้งเตือนจากบัญชีนี้เนื่องจากมีการจำกัดบัญชีโดยผู้กลั่นกรอง",
  "notification_requests.explainer_for_limited_remote_account": "มีการกรองการแจ้งเตือนจากบัญชีนี้เนื่องจากมีการจำกัดบัญชีหรือเซิร์ฟเวอร์ของบัญชีโดยผู้กลั่นกรอง",
  "notification_requests.maximize": "ขยายใหญ่สุด",
  "notification_requests.minimize_banner": "ย่อแบนเนอร์การแจ้งเตือนที่กรองอยู่ให้เล็กสุด",
  "notification_requests.notifications_from": "การแจ้งเตือนจาก {name}",
  "notification_requests.title": "การแจ้งเตือนที่กรองอยู่",
  "notification_requests.view": "ดูการแจ้งเตือน",
  "notifications.clear": "ล้างการแจ้งเตือน",
  "notifications.clear_confirmation": "คุณแน่ใจหรือไม่ว่าต้องการล้างการแจ้งเตือนทั้งหมดของคุณอย่างถาวร?",
  "notifications.clear_title": "ล้างการแจ้งเตือน?",
  "notifications.column_settings.admin.report": "รายงานใหม่:",
  "notifications.column_settings.admin.sign_up": "การลงทะเบียนใหม่:",
  "notifications.column_settings.alert": "การแจ้งเตือนบนเดสก์ท็อป",
  "notifications.column_settings.favourite": "รายการโปรด:",
  "notifications.column_settings.filter_bar.advanced": "แสดงหมวดหมู่ทั้งหมด",
  "notifications.column_settings.filter_bar.category": "แถบตัวกรองด่วน",
  "notifications.column_settings.follow": "ผู้ติดตามใหม่:",
  "notifications.column_settings.follow_request": "คำขอติดตามใหม่:",
  "notifications.column_settings.group": "จัดกลุ่ม",
  "notifications.column_settings.mention": "การกล่าวถึง:",
  "notifications.column_settings.poll": "ผลลัพธ์การสำรวจความคิดเห็น:",
  "notifications.column_settings.push": "การแจ้งเตือนแบบผลัก",
  "notifications.column_settings.quote": "การอ้างอิง:",
  "notifications.column_settings.reblog": "การดัน:",
  "notifications.column_settings.show": "แสดงในคอลัมน์",
  "notifications.column_settings.sound": "เล่นเสียง",
  "notifications.column_settings.status": "โพสต์ใหม่:",
  "notifications.column_settings.unread_notifications.category": "การแจ้งเตือนที่ยังไม่ได้อ่าน",
  "notifications.column_settings.unread_notifications.highlight": "เน้นการแจ้งเตือนที่ยังไม่ได้อ่าน",
  "notifications.column_settings.update": "การแก้ไข:",
  "notifications.filter.all": "ทั้งหมด",
  "notifications.filter.boosts": "การดัน",
  "notifications.filter.favourites": "รายการโปรด",
  "notifications.filter.follows": "การติดตาม",
  "notifications.filter.mentions": "การกล่าวถึง",
  "notifications.filter.polls": "ผลลัพธ์การสำรวจความคิดเห็น",
  "notifications.filter.statuses": "การอัปเดตจากผู้คนที่คุณติดตาม",
  "notifications.grant_permission": "ให้สิทธิอนุญาต",
  "notifications.group": "{count} การแจ้งเตือน",
  "notifications.mark_as_read": "ทำเครื่องหมายทุกการแจ้งเตือนว่าอ่านแล้ว",
  "notifications.permission_denied": "การแจ้งเตือนบนเดสก์ท็อปไม่พร้อมใช้งานเนื่องจากมีการปฏิเสธคำขอสิทธิอนุญาตเบราว์เซอร์ก่อนหน้านี้",
  "notifications.permission_denied_alert": "ไม่สามารถเปิดใช้งานการแจ้งเตือนบนเดสก์ท็อป เนื่องจากมีการปฏิเสธสิทธิอนุญาตเบราว์เซอร์ก่อนหน้านี้",
  "notifications.permission_required": "การแจ้งเตือนบนเดสก์ท็อปไม่พร้อมใช้งานเนื่องจากไม่ได้ให้สิทธิอนุญาตที่จำเป็น",
  "notifications.policy.accept": "ยอมรับ",
  "notifications.policy.accept_hint": "แสดงในการแจ้งเตือน",
  "notifications.policy.drop": "เพิกเฉย",
  "notifications.policy.drop_hint": "ละทิ้งอย่างถาวร ไม่ให้เห็นอีกเลย",
  "notifications.policy.filter": "กรอง",
  "notifications.policy.filter_hint": "ส่งไปยังกล่องขาเข้าการแจ้งเตือนที่กรองอยู่",
  "notifications.policy.filter_limited_accounts_hint": "จำกัดโดยผู้กลั่นกรองเซิร์ฟเวอร์",
  "notifications.policy.filter_limited_accounts_title": "บัญชีที่ได้รับการกลั่นกรอง",
  "notifications.policy.filter_new_accounts.hint": "สร้างขึ้นภายใน {days, plural, other {# วัน}}ที่ผ่านมา",
  "notifications.policy.filter_new_accounts_title": "บัญชีใหม่",
  "notifications.policy.filter_not_followers_hint": "รวมถึงผู้คนที่ได้ติดตามคุณน้อยกว่า {days, plural, other {# วัน}}",
  "notifications.policy.filter_not_followers_title": "ผู้คนที่ไม่ได้ติดตามคุณ",
  "notifications.policy.filter_not_following_hint": "จนกว่าคุณจะอนุมัติเขาด้วยตนเอง",
  "notifications.policy.filter_not_following_title": "ผู้คนที่คุณไม่ได้ติดตาม",
  "notifications.policy.filter_private_mentions_hint": "กรองไว้เว้นแต่การกล่าวถึงแบบส่วนตัวอยู่ในการตอบกลับการกล่าวถึงของคุณเองหรือหากคุณติดตามผู้ส่ง",
  "notifications.policy.filter_private_mentions_title": "การกล่าวถึงแบบส่วนตัวที่ไม่พึงประสงค์",
  "notifications.policy.title": "จัดการการแจ้งเตือนจาก…",
  "notifications_permission_banner.enable": "เปิดใช้งานการแจ้งเตือนบนเดสก์ท็อป",
  "notifications_permission_banner.how_to_control": "เพื่อรับการแจ้งเตือนเมื่อ Mastodon ไม่ได้เปิด เปิดใช้งานการแจ้งเตือนบนเดสก์ท็อป คุณสามารถควบคุมชนิดของการโต้ตอบที่สร้างการแจ้งเตือนบนเดสก์ท็อปได้อย่างแม่นยำผ่านปุ่ม {icon} ด้านบนเมื่อเปิดใช้งานการแจ้งเตือน",
  "notifications_permission_banner.title": "ไม่พลาดสิ่งใด",
  "onboarding.follows.back": "ย้อนกลับ",
  "onboarding.follows.empty": "น่าเสียดาย ไม่สามารถแสดงผลลัพธ์ได้ในตอนนี้ คุณสามารถลองใช้การค้นหาหรือเรียกดูหน้าสำรวจเพื่อค้นหาผู้คนที่จะติดตาม หรือลองอีกครั้งในภายหลัง",
  "onboarding.follows.next": "ต่อไป: ตั้งค่าโปรไฟล์ของคุณ",
  "onboarding.follows.search": "ค้นหา",
  "onboarding.follows.title": "ติดตามผู้คนเพื่อเริ่มต้นใช้งาน",
  "onboarding.profile.discoverable": "ทำให้โปรไฟล์ของฉันสามารถค้นพบได้",
  "onboarding.profile.discoverable_hint": "เมื่อคุณเลือกรับความสามารถในการค้นพบใน Mastodon โพสต์ของคุณอาจปรากฏในผลลัพธ์การค้นหาและกำลังนิยม และอาจเสนอแนะโปรไฟล์ของคุณให้กับผู้คนที่มีความสนใจคล้ายกับคุณ",
  "onboarding.profile.display_name": "ชื่อที่แสดง",
  "onboarding.profile.display_name_hint": "ชื่อเต็มของคุณหรือชื่อแบบสนุกสนานของคุณ…",
  "onboarding.profile.note": "ชีวประวัติ",
  "onboarding.profile.note_hint": "คุณสามารถ @กล่าวถึง ผู้คนอื่น ๆ หรือ #แฮชแท็ก…",
  "onboarding.profile.title": "การตั้งค่าโปรไฟล์",
  "onboarding.profile.upload_avatar": "อัปโหลดรูปภาพโปรไฟล์",
  "onboarding.profile.upload_header": "อัปโหลดส่วนหัวโปรไฟล์",
  "password_confirmation.exceeds_maxlength": "การยืนยันรหัสผ่านเกินความยาวรหัสผ่านสูงสุดแล้ว",
  "password_confirmation.mismatching": "การยืนยันรหัสผ่านไม่ตรงกัน",
  "picture_in_picture.restore": "นำหน้าต่างย่อยในหน้าต่างหลักกลับมา",
  "poll.closed": "ปิดแล้ว",
  "poll.refresh": "รีเฟรช",
  "poll.reveal": "ดูผลลัพธ์",
  "poll.total_people": "{count, plural, other {# คน}}",
  "poll.total_votes": "{count, plural, other {# การลงคะแนน}}",
  "poll.vote": "ลงคะแนน",
  "poll.voted": "คุณได้ลงคะแนนให้กับคำตอบนี้",
  "poll.votes": "{votes, plural, other {# การลงคะแนน}}",
  "poll_button.add_poll": "เพิ่มการสำรวจความคิดเห็น",
  "poll_button.remove_poll": "เอาการสำรวจความคิดเห็นออก",
  "privacy.change": "เปลี่ยนความเป็นส่วนตัวของโพสต์",
  "privacy.direct.long": "ทุกคนที่กล่าวถึงในโพสต์",
  "privacy.direct.short": "การกล่าวถึงแบบส่วนตัว",
  "privacy.private.long": "เฉพาะผู้ติดตามของคุณเท่านั้น",
  "privacy.private.short": "ผู้ติดตาม",
  "privacy.public.long": "ใครก็ตามที่อยู่ในและนอก Mastodon",
  "privacy.public.short": "สาธารณะ",
  "privacy.quote.disabled": "{visibility}, ปิดใช้งานการอ้างอิงแล้ว",
  "privacy.quote.limited": "{visibility}, จำกัดการอ้างอิงอยู่",
  "privacy.unlisted.additional": "สิ่งนี้ทำงานเหมือนกับสาธารณะทุกประการ ยกเว้นโพสต์จะไม่ปรากฏในฟีดสดหรือแฮชแท็ก, การสำรวจ หรือการค้นหา Mastodon แม้ว่าคุณได้เลือกรับทั่วทั้งบัญชีก็ตาม",
  "privacy.unlisted.long": "ซ่อนจากผลลัพธ์การค้นหา, กำลังนิยม และเส้นเวลาสาธารณะของ Mastodon",
  "privacy.unlisted.short": "สาธารณะแบบเงียบ",
  "privacy_policy.last_updated": "อัปเดตล่าสุดเมื่อ {date}",
  "privacy_policy.title": "นโยบายความเป็นส่วนตัว",
  "recommended": "แนะนำ",
  "refresh": "รีเฟรช",
  "regeneration_indicator.please_stand_by": "โปรดรอสักครู่",
  "regeneration_indicator.preparing_your_home_feed": "กำลังเตรียมฟีดหน้าแรกของคุณ…",
  "relative_time.days": "{number} วัน",
  "relative_time.full.days": "{number, plural, other {# วัน}}ที่แล้ว",
  "relative_time.full.hours": "{number, plural, other {# ชั่วโมง}}ที่แล้ว",
  "relative_time.full.just_now": "เมื่อกี้นี้",
  "relative_time.full.minutes": "{number, plural, other {# นาที}}ที่แล้ว",
  "relative_time.full.seconds": "{number, plural, other {# วินาที}}ที่แล้ว",
  "relative_time.hours": "{number} ชั่วโมง",
  "relative_time.just_now": "ตอนนี้",
  "relative_time.minutes": "{number} นาที",
  "relative_time.seconds": "{number} วินาที",
  "relative_time.today": "วันนี้",
  "remove_quote_hint.button_label": "เข้าใจแล้ว",
  "reply_indicator.attachments": "{count, plural, other {# ไฟล์แนบ}}",
  "reply_indicator.cancel": "ยกเลิก",
  "reply_indicator.poll": "การสำรวจความคิดเห็น",
  "report.block": "ปิดกั้น",
  "report.block_explanation": "คุณจะไม่เห็นโพสต์ของเขา เขาจะไม่สามารถเห็นโพสต์ของคุณหรือติดตามคุณ เขาจะสามารถบอกได้ว่ามีการปิดกั้นเขา",
  "report.categories.legal": "กฎหมาย",
  "report.categories.other": "อื่น ๆ",
  "report.categories.spam": "สแปม",
  "report.categories.violation": "เนื้อหาละเมิดกฎของเซิร์ฟเวอร์จำนวนหนึ่งหรือมากกว่า",
  "report.category.subtitle": "เลือกที่ตรงกันที่สุด",
  "report.close": "เสร็จสิ้น",
  "report.comment.title": "มีสิ่งอื่นใดที่คุณคิดว่าเราควรทราบหรือไม่?",
  "report.forward": "ส่งต่อไปยัง {target}",
  "report.forward_hint": "บัญชีมาจากเซิร์ฟเวอร์อื่น ส่งสำเนาที่ไม่ระบุตัวตนของรายงานไปที่นั่นด้วย?",
  "report.mute": "ซ่อน",
  "report.mute_explanation": "คุณจะไม่เห็นโพสต์ของเขา เขายังคงสามารถติดตามคุณและเห็นโพสต์ของคุณและจะไม่ทราบว่ามีการซ่อนเขา",
  "report.next": "ถัดไป",
  "report.placeholder": "ความคิดเห็นเพิ่มเติม",
  "report.reasons.dislike": "ฉันไม่ชอบโพสต์",
  "report.reasons.dislike_description": "โพสต์ไม่ใช่บางอย่างที่คุณต้องการเห็น",
  "report.reasons.legal": "โพสต์ผิดกฎหมาย",
  "report.reasons.legal_description": "คุณเชื่อว่าโพสต์ละเมิดกฎหมายของประเทศของคุณหรือของเซิร์ฟเวอร์",
  "report.reasons.other": "โพสต์เป็นอย่างอื่น",
  "report.reasons.other_description": "ปัญหาไม่เข้าหมวดหมู่อื่น ๆ",
  "report.reasons.spam": "โพสต์เป็นสแปม",
  "report.reasons.spam_description": "ลิงก์ที่เป็นอันตราย, การมีส่วนร่วมปลอม หรือการตอบกลับซ้ำ ๆ",
  "report.reasons.violation": "โพสต์ละเมิดกฎของเซิร์ฟเวอร์",
  "report.reasons.violation_description": "คุณตระหนักว่าโพสต์แหกกฎที่เฉพาะเจาะจง",
  "report.rules.subtitle": "เลือกทั้งหมดที่นำไปใช้",
  "report.rules.title": "กำลังละเมิดกฎใด?",
  "report.statuses.subtitle": "เลือกทั้งหมดที่นำไปใช้",
  "report.statuses.title": "มีโพสต์ใด ๆ ที่สนับสนุนรายงานนี้หรือไม่?",
  "report.submit": "ส่ง",
  "report.target": "กำลังรายงาน {target}",
  "report.thanks.take_action": "นี่คือตัวเลือกของคุณสำหรับการควบคุมสิ่งที่คุณเห็นใน Mastodon:",
  "report.thanks.take_action_actionable": "ขณะที่เราตรวจทานสิ่งนี้ คุณสามารถใช้การกระทำต่อ @{name}:",
  "report.thanks.title": "ไม่ต้องการเห็นสิ่งนี้?",
  "report.thanks.title_actionable": "ขอบคุณสำหรับการรายงาน เราจะตรวจสอบสิ่งนี้",
  "report.unfollow": "เลิกติดตาม @{name}",
  "report.unfollow_explanation": "คุณกำลังติดตามบัญชีนี้ เพื่อไม่ให้เห็นโพสต์ของเขาในฟีดหน้าแรกของคุณอีกต่อไป ให้เลิกติดตามเขา",
  "report_notification.attached_statuses": "{count, plural, other {{count} โพสต์}}ที่แนบมา",
  "report_notification.categories.legal": "กฎหมาย",
  "report_notification.categories.legal_sentence": "เนื้อหาที่ผิดกฎหมาย",
  "report_notification.categories.other": "อื่น ๆ",
  "report_notification.categories.other_sentence": "อื่น ๆ",
  "report_notification.categories.spam": "สแปม",
  "report_notification.categories.spam_sentence": "สแปม",
  "report_notification.categories.violation": "การละเมิดกฎ",
  "report_notification.categories.violation_sentence": "การละเมิดกฎ",
  "report_notification.open": "รายงานที่เปิด",
  "search.clear": "ล้างการค้นหา",
  "search.no_recent_searches": "ไม่มีการค้นหาล่าสุด",
  "search.placeholder": "ค้นหา",
  "search.quick_action.account_search": "โปรไฟล์ที่ตรงกับ {x}",
  "search.quick_action.go_to_account": "ไปยังโปรไฟล์ {x}",
  "search.quick_action.go_to_hashtag": "ไปยังแฮชแท็ก {x}",
  "search.quick_action.open_url": "เปิด URL ใน Mastodon",
  "search.quick_action.status_search": "โพสต์ที่ตรงกับ {x}",
  "search.search_or_paste": "ค้นหาหรือวาง URL",
  "search_popout.full_text_search_disabled_message": "ไม่พร้อมใช้งานใน {domain}",
  "search_popout.full_text_search_logged_out_message": "พร้อมใช้งานเฉพาะเมื่อเข้าสู่ระบบแล้วเท่านั้น",
  "search_popout.language_code": "รหัสภาษา ISO",
  "search_popout.options": "ตัวเลือกการค้นหา",
  "search_popout.quick_actions": "การกระทำด่วน",
  "search_popout.recent": "การค้นหาล่าสุด",
  "search_popout.specific_date": "วันที่ที่เฉพาะเจาะจง",
  "search_popout.user": "ผู้ใช้",
  "search_results.accounts": "โปรไฟล์",
  "search_results.all": "ทั้งหมด",
  "search_results.hashtags": "แฮชแท็ก",
  "search_results.no_results": "ไม่มีผลลัพธ์",
  "search_results.see_all": "ดูทั้งหมด",
  "search_results.statuses": "โพสต์",
  "search_results.title": "ค้นหาสำหรับ \"{q}\"",
  "server_banner.about_active_users": "ผู้คนที่ใช้เซิร์ฟเวอร์นี้ในระหว่าง 30 วันที่ผ่านมา (ผู้ใช้ที่ใช้งานอยู่รายเดือน)",
  "server_banner.active_users": "ผู้ใช้ที่ใช้งานอยู่",
  "server_banner.administered_by": "ดูแลโดย:",
  "server_banner.is_one_of_many": "{domain} เป็นหนึ่งในเซิร์ฟเวอร์ Mastodon อิสระจำนวนมากที่คุณสามารถใช้เพื่อมีส่วนร่วมในจักรวาลสหพันธ์",
  "server_banner.server_stats": "สถิติเซิร์ฟเวอร์:",
  "sign_in_banner.create_account": "สร้างบัญชี",
  "sign_in_banner.follow_anyone": "ติดตามใครก็ตามทั่วทั้งจักรวาลสหพันธ์และดูจักรวาลสหพันธ์ทั้งหมดตามลำดับเวลา ไม่มีอัลกอริทึม, โฆษณา หรือคลิกเบตอยู่ในสายตา",
  "sign_in_banner.mastodon_is": "Mastodon เป็นวิธีที่ดีที่สุดที่จะติดตามสิ่งที่กำลังเกิดขึ้น",
  "sign_in_banner.sign_in": "เข้าสู่ระบบ",
  "sign_in_banner.sso_redirect": "เข้าสู่ระบบหรือลงทะเบียน",
  "status.admin_account": "เปิดส่วนติดต่อการกลั่นกรองสำหรับ @{name}",
  "status.admin_domain": "เปิดส่วนติดต่อการกลั่นกรองสำหรับ {domain}",
  "status.admin_status": "เปิดโพสต์นี้ในส่วนติดต่อการกลั่นกรอง",
  "status.block": "ปิดกั้น @{name}",
  "status.bookmark": "เพิ่มที่คั่นหน้า",
  "status.cancel_reblog_private": "เลิกดัน",
  "status.cannot_reblog": "ไม่สามารถดันโพสต์นี้",
  "status.context.retry": "ลองใหม่",
  "status.context.show": "แสดง",
  "status.continued_thread": "กระทู้ต่อเนื่อง",
  "status.copy": "คัดลอกลิงก์ไปยังโพสต์",
  "status.delete": "ลบ",
  "status.delete.success": "ลบโพสต์แล้ว",
  "status.detailed_status": "มุมมองการสนทนาโดยละเอียด",
  "status.direct": "กล่าวถึง @{name} แบบส่วนตัว",
  "status.direct_indicator": "การกล่าวถึงแบบส่วนตัว",
  "status.edit": "แก้ไข",
  "status.edited": "แก้ไขล่าสุดเมื่อ {date}",
  "status.edited_x_times": "แก้ไข {count, plural, other {{count} ครั้ง}}",
  "status.embed": "รับโค้ดฝังตัว",
  "status.favourite": "ชื่นชอบ",
  "status.filter": "กรองโพสต์นี้",
  "status.history.created": "{name} ได้สร้างเมื่อ {date}",
  "status.history.edited": "{name} ได้แก้ไขเมื่อ {date}",
  "status.load_more": "โหลดเพิ่มเติม",
  "status.media.open": "คลิกเพื่อเปิด",
  "status.media.show": "คลิกเพื่อแสดง",
  "status.media_hidden": "ซ่อนสื่ออยู่",
  "status.mention": "กล่าวถึง @{name}",
  "status.more": "เพิ่มเติม",
  "status.mute": "ซ่อน @{name}",
  "status.mute_conversation": "ซ่อนการสนทนา",
  "status.open": "ขยายโพสต์นี้",
  "status.pin": "ปักหมุดในโปรไฟล์",
  "status.quote_error.limited_account_hint.action": "แสดงต่อไป",
  "status.quote_followers_only": "เฉพาะผู้ติดตามเท่านั้นที่สามารถอ้างอิงโพสต์นี้ได้",
  "status.quote_post_author": "อ้างอิงโพสต์โดย @{name}",
  "status.read_more": "อ่านเพิ่มเติม",
  "status.reblog": "ดัน",
  "status.reblog_private": "แชร์อีกครั้งกับผู้ติดตามของคุณ",
  "status.reblogged_by": "{name} ได้ดัน",
  "status.reblogs.empty": "ยังไม่มีใครดันโพสต์นี้ เมื่อใครสักคนดัน เขาจะปรากฏที่นี่",
  "status.redraft": "ลบแล้วร่างใหม่",
  "status.remove_bookmark": "เอาที่คั่นหน้าออก",
  "status.remove_favourite": "เอาออกจากรายการโปรด",
  "status.remove_quote": "เอาออก",
  "status.replied_in_thread": "ตอบกลับในกระทู้",
  "status.replied_to": "ตอบกลับ {name}",
  "status.reply": "ตอบกลับ",
  "status.replyAll": "ตอบกลับกระทู้",
  "status.report": "รายงาน @{name}",
  "status.sensitive_warning": "เนื้อหาที่ละเอียดอ่อน",
  "status.share": "แชร์",
  "status.show_less_all": "แสดงน้อยลงทั้งหมด",
  "status.show_more_all": "แสดงเพิ่มเติมทั้งหมด",
  "status.show_original": "แสดงดั้งเดิม",
  "status.title.with_attachments": "{user} ได้โพสต์ {attachmentCount, plural, other {{attachmentCount} ไฟล์แนบ}}",
  "status.translate": "แปล",
  "status.translated_from_with": "แปลจาก {lang} โดยใช้ {provider}",
  "status.uncached_media_warning": "ตัวอย่างไม่พร้อมใช้งาน",
  "status.unmute_conversation": "เลิกซ่อนการสนทนา",
  "status.unpin": "ถอนหมุดจากโปรไฟล์",
  "subscribed_languages.lead": "เฉพาะโพสต์ในภาษาที่เลือกเท่านั้นที่จะปรากฏในเส้นเวลาหน้าแรกและรายการหลังจากการเปลี่ยนแปลง เลือก ไม่มี เพื่อรับโพสต์ในภาษาทั้งหมด",
  "subscribed_languages.save": "บันทึกการเปลี่ยนแปลง",
  "subscribed_languages.target": "เปลี่ยนภาษาที่บอกรับสำหรับ {target}",
  "tabs_bar.home": "หน้าแรก",
  "tabs_bar.menu": "เมนู",
  "tabs_bar.notifications": "การแจ้งเตือน",
  "tabs_bar.publish": "โพสต์ใหม่",
  "tabs_bar.search": "ค้นหา",
  "terms_of_service.title": "เงื่อนไขการให้บริการ",
  "time_remaining.days": "เหลืออีก {number, plural, other {# วัน}}",
  "time_remaining.hours": "เหลืออีก {number, plural, other {# ชั่วโมง}}",
  "time_remaining.minutes": "เหลืออีก {number, plural, other {# นาที}}",
  "time_remaining.moments": "ช่วงเวลาที่เหลือ",
  "time_remaining.seconds": "เหลืออีก {number, plural, other {# วินาที}}",
  "trends.counter_by_accounts": "{count, plural, other {{counter} คน}}ใน {days, plural, other {{days} วัน}}ที่ผ่านมา",
  "trends.trending_now": "กำลังนิยม",
  "ui.beforeunload": "แบบร่างของคุณจะสูญหายหากคุณออกจาก Mastodon",
  "units.short.billion": "{count} พันล้าน",
  "units.short.million": "{count} ล้าน",
  "units.short.thousand": "{count} พัน",
  "upload_area.title": "ลากแล้วปล่อยเพื่ออัปโหลด",
  "upload_button.label": "เพิ่มไฟล์ภาพ, วิดีโอ หรือเสียง",
  "upload_error.limit": "เกินขีดจำกัดการอัปโหลดไฟล์แล้ว",
  "upload_error.poll": "ไม่อนุญาตการอัปโหลดไฟล์โดยมีการสำรวจความคิดเห็น",
  "upload_form.drag_and_drop.instructions": "เพื่อหยิบไฟล์แนบสื่อ กดปุ่มเว้นวรรคหรือขึ้นบรรทัดใหม่ ขณะลาก ใช้ปุ่มลูกศรเพื่อย้ายไฟล์แนบสื่อในทิศทางใดก็ตามที่กำหนด กดปุ่มเว้นวรรคหรือขึ้นบรรทัดใหม่อีกครั้งเพื่อปล่อยไฟล์แนบสื่อในตำแหน่งใหม่ หรือกดปุ่ม Escape เพื่อยกเลิก",
  "upload_form.drag_and_drop.on_drag_cancel": "ยกเลิกการลากแล้ว ปล่อยไฟล์แนบสื่อ {item} แล้ว",
  "upload_form.drag_and_drop.on_drag_end": "ปล่อยไฟล์แนบสื่อ {item} แล้ว",
  "upload_form.drag_and_drop.on_drag_over": "ย้ายไฟล์แนบสื่อ {item} แล้ว",
  "upload_form.drag_and_drop.on_drag_start": "หยิบไฟล์แนบสื่อ {item} แล้ว",
  "upload_form.edit": "แก้ไข",
  "upload_progress.label": "กำลังอัปโหลด...",
  "upload_progress.processing": "กำลังประมวลผล…",
  "username.taken": "มีการใช้ชื่อผู้ใช้นั้นแล้ว ลองอย่างอื่น",
  "video.close": "ปิดวิดีโอ",
  "video.download": "ดาวน์โหลดไฟล์",
  "video.exit_fullscreen": "ออกจากเต็มหน้าจอ",
  "video.expand": "ขยายวิดีโอ",
  "video.fullscreen": "เต็มหน้าจอ",
  "video.hide": "ซ่อนวิดีโอ",
  "video.mute": "ปิดเสียง",
  "video.pause": "หยุดชั่วคราว",
  "video.play": "เล่น",
  "video.unmute": "เลิกปิดเสียง",
  "visibility_modal.button_title": "ตั้งการมองเห็น",
  "visibility_modal.header": "การมองเห็นและการโต้ตอบ",
  "visibility_modal.privacy_label": "การมองเห็น",
  "visibility_modal.quote_followers": "ผู้ติดตามเท่านั้น",
  "visibility_modal.quote_nobody": "แค่ฉัน",
  "visibility_modal.quote_public": "ใครก็ตาม",
  "visibility_modal.save": "บันทึก"
}
